import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import CommandDialog from './CommandDialog';
import ComponentPanel from './ComponentPanel';

class ComponentUpgrade extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.onUpdate = this.onShowDialog.bind(this, true);
		this.onCloseDialog = this.onShowDialog.bind(this, false);
		this.onRefresh = this.onRefresh.bind(this);
		this.state = {
			showUpdateModal: false
		};
	}

	onShowDialog(show, ev) {
		if (ev) {
			// close is not always triggered by ev
			ev.preventDefault();
			ev.stopPropagation();
		}
		this.setState({ showUpdateModal: show });
	}

	onRefresh() {
		this.props.refresh();
	}

	renderUpdateModal() {
		const text = (
			<div>
				<p>
					{this.intl.formatMsg('Running the install command will upgrade this component. Upgrading is important for support, applying security and bug fixes, and should be done when upgrades are available. To upgrade, do the following:')}
				</p>
				<ol>
					<li>{this.intl.formatMsg('Go to the terminal window and exit the application.')}</li>
					<li>{this.intl.formatMsg('Run the command(s) below.')}</li>
					<li>{this.intl.formatMsg('Restart the server.')}</li>
					<li>{this.intl.formatMsg('Once the server is restarted, click the "Refresh" button to refresh the page.')}</li>
				</ol>
			</div>
		);
		const commands = this.props.upgrade.install.join('\n');

		return (
			<CommandDialog
				title={this.intl.formatMsg('Upgrade {name}', { name: this.props.upgrade.name })}
				text={text}
				command={commands}
				onClose={this.onCloseDialog}
				onOkay={this.onRefresh}
				closeText={this.intl.formatMsg('Cancel')}
				okayText={this.intl.formatMsg('Refresh')}
				okayIcon="redo2"
			/>
		);
	}

	render() {
		const { upgrade: component } = this.props;

		return (
			<div>
				{this.state.showUpdateModal && this.renderUpdateModal()}
				<ComponentPanel
					title={component.name}
					type="upgrades"
					onInstall={this.onUpdate}
					components={[ this.props.upgrade ]}
					hasUpdates={this.props.hasUpdates}
					productName={this.props.productName}
				/>
			</div>
		);
	}
}

ComponentUpgrade.propTypes = {
	/**
	 * The updates available for the service.
	 */
	upgrade: PropTypes.object.isRequired,
	/**
	 *
	 */
	hasUpdates: PropTypes.bool.isRequired,
	/**
	 * The function to use to refresh the UI
	 */
	refresh: PropTypes.func.isRequired,
	/**
	 * The product name.
	 */
	productName: PropTypes.string.isRequired
};

export default injectIntl(ComponentUpgrade);
